import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RenewSubscriptionComponent } from './renew-subscription';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription.renew-subscription', {
            url: '/renew-subscription',
            data: {
                authorisationLevel: 1,
                pageTitle: 'Subscription Expiration'
            },
            'views': {
                'multiContentUnsubscription': {
                    template: '<renew-subscription flex="100"></renew-subscription>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RenewSubscriptionModule: string = ng
    .module('renew-subscription', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('renewSubscription', RenewSubscriptionComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/renew-subscription/renew-subscription.module.ts